import { z } from "zod";

export const completedCasesQualitySchema = z.enum([
  "GOOD",
  "STALE",
  "COUNTER_RESET",
  "BASELINE_MISSING",
  "GAP_ACROSS_RUN",
  "NO_DATA",
]);

const dateTimeSchema = z.string().datetime({ offset: true });

export const productionLineMonitorResponseSchema = z.object({
  available: z.boolean(),
  unavailableReason: z.string().trim().min(1).max(200).nullable(),
  serverTime: dateTimeSchema,
  line: z.object({
    id: z.string().uuid(),
    name: z.literal("TAMTAŞ SİLİNDİR"),
  }).strict().nullable(),
  machine: z.object({
    running: z.boolean().nullable(),
    measuredAt: dateTimeSchema.nullable(),
    receivedAt: dateTimeSchema.nullable(),
  }).strict(),
  counter: z.object({
    rawCases: z.number().int().nonnegative().nullable(),
    runCases: z.number().int().nonnegative().nullable(),
    measuredAt: dateTimeSchema.nullable(),
    quality: completedCasesQualitySchema,
  }).strict(),
  run: z.object({
    id: z.string().uuid(),
    workOrderNo: z.string().trim().min(1).max(80),
    productName: z.string().trim().min(1).max(240),
    plannedCases: z.number().finite().nonnegative().nullable(),
    startedAt: dateTimeSchema,
  }).strict().nullable(),
  downtimeSummary: z.object({
    eventCount: z.number().int().nonnegative(),
    totalMilliseconds: z.number().int().nonnegative(),
    openStartedAt: dateTimeSchema.nullable(),
  }).strict(),
  downtimes: z.array(z.object({
    id: z.string().uuid(),
    startedAt: dateTimeSchema,
    endedAt: dateTimeSchema.nullable(),
    reasonName: z.string().trim().min(1).max(240).nullable(),
  }).strict()).max(100),
}).strict();

export type CompletedCasesQuality = z.infer<typeof completedCasesQualitySchema>;
export type ProductionLineMonitorResponse = z.infer<typeof productionLineMonitorResponseSchema>;
